export const SensitiveInfo = {
  title: 'Sensitive Documents',
  processing:
    "When you mark documents as sensitive, we will only use them for processing. Immediately after, your browser will download the processed files, and we will automatically delete the uploaded documents. You'll see the batch in your History, but without the files for export.",
  recovery:
    "If you lose your local copy, you'll need to reprocess the documents.",
} as const;
